import React, { useState } from 'react';
import { Instagram, Mail } from 'lucide-react';
import { ContactModal } from './ContactModal';

export function Footer() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <footer className="bg-[#fdfbf7] border-t border-[#eaddcf] py-12">
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center">
        <div className="mb-6 md:mb-0 text-center md:text-left">
          <h4 className="font-serif text-xl text-[#c5a059] font-bold tracking-widest mb-2">FABIHA ZAMAN</h4>
          <p className="text-sm text-gray-500">Self-love & cultural rewiring coach.</p>
        </div>

        <div className="flex space-x-6 mb-6 md:mb-0 items-center">
          <a href="https://www.instagram.com/freespiritfabiha/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#d48c95] transition flex items-center justify-center"><Instagram size={24} /></a>
          <button
            onClick={() => setIsContactModalOpen(true)}
            className="text-gray-400 hover:text-[#d48c95] transition focus:outline-none flex items-center justify-center"
            aria-label="Contact Me"
          >
            <Mail size={24} />
          </button>
        </div>

        <div className="text-xs text-gray-400 text-center md:text-right">
          <p>© {new Date().getFullYear()} FreeSpiritFabiha. All rights reserved.</p>
          <p>London, UK</p>
        </div>
      </div>

      <ContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
    </footer>
  );
}

export default Footer;
